<template>
    <div class="password-reset-page">
        <div class="password-reset-page-content">
            <el-form @submit.prevent.native="onSubmit('form')" :model="form" :rules="rules" status-icon ref="form" label-width="130px">
                <el-form-item label="Password" prop="password">
                    <div class="row">
                        <div class="col-lg-12">
                            <el-input ref="password" type="password" v-model="form.password" autocomplete="off"></el-input>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item label="Confirm Password" prop="password_confirmation">
                    <div class="row">
                        <div class="col-lg-12">
                            <el-input type="password" v-model="form.password_confirmation" autocomplete="off"></el-input>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item>
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="flex-space">
                                <router-link class="el-button el-button--primary is-plain button-submit" native-type="submit"
                                             type="primary" to="/login">Login
                                </router-link>
                                <el-button native-type="submit" type="primary" class="button-submit" :loading="false" plain
                                           v-loading.fullscreen.lock="fullscreenLoading">Change Password
                                </el-button>
                            </div>
                        </div>
                    </div>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
import { HTTP } from '@/services/api'
export default {
  name: 'ChangePassword',
  metaInfo: {
    title: 'ChangePassword'
  },
  data () {
    return {
      fullscreenLoading: false,
      form: {
        password: '',
        password_confirmation: ''
      },
      rules: {
        password: [
          { required: true, message: 'Please enter password', trigger: ['blur'] }
        ],
        password_confirmation: [
          { required: true, message: 'Please confirm password', trigger: ['blur'] }
        ]
      }
    }
  },
  mounted () {
    let self = this
    // if (!self.checkPayload()) {
    //   self.$router.push('/login')
    // }
    self.$refs.password.focus()
  },
  methods: {
    checkPayload () {
      let self = this
      HTTP({
        method: 'POST',
        url: '/api/v1validate/password/token',
        data: {
          token: self.$route.params.token,
          email: self.$store.state.user.email
        }
      }).then(() => {
        self.fullscreenLoading = false
        // self.$router.push('/login')
        self.$notify({
          title: 'Information',
          message: 'Password has been updated.',
          type: 'success',
          customClass: 'notify',
          position: 'bottom-right',
          duration: 4500
        })
      }).catch(error => {
        self.fullscreenLoading = false
        self.$notify({
          title: self.$i18n.t('messages.error'),
          message: self.$helpers.errorMessageHandler(error),
          type: 'error',
          customClass: 'notify',
          position: 'bottom-right',
          duration: 6500
        })
      })
    },
    onSubmit (formName) {
      let self = this
      self.fullscreenLoading = true
      self.$refs[formName].validate((valid) => {
        if (!valid) {
          self.fullscreenLoading = false
        } else {
          HTTP({
            method: 'POST',
            url: '/api/v1/password/reset',
            data: {
              token: self.$route.params.token,
              email: self.$store.state.user.email,
              password: self.form.password,
              password_confirmation: self.form.password_confirmation
            }
          }).then(response => {
            self.fullscreenLoading = false
            self.$notify({
              title: 'Information',
              message: response.data.data,
              type: 'success',
              customClass: 'notify',
              position: 'bottom-right',
              duration: 4500
            })
          }).catch(error => {
            self.fullscreenLoading = false
            self.$notify({
              title: self.$i18n.t('messages.error'),
              message: self.$helpers.errorMessageHandler(error),
              type: 'error',
              customClass: 'notify',
              position: 'bottom-right',
              duration: 4500
            })
          })
        }
      })
    }
  }
}
</script>
